"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const pause = () => {
    const screen = document.getElementById("screen");
    if (screen) {
        screen.classList.add("paused");
        const pauses = state_1.default.pauses;
        pauses.push({
            pausedAt: state_1.default.currentTime,
            unpausedAt: null
        });
        state_1.default.pauses = pauses;
    }
};
exports.default = pause;
